import { useEffect, useState, useMemo } from 'react';
import { throttle } from 'lodash';

const useScrollPosition = (wait = 150) => {
    const [scrollYPosition, setScrollYPosition] = useState(0);
    const [scrollYDirection, setScrollYDirection] = useState();
    const waitTime = wait;
    let prevScrollY = 0;

    const updatePosition = () => {
        if (typeof window !== 'undefined') {
            if (window.pageYOffset) {
                let scrollY = window.pageYOffset;

                if (scrollY > prevScrollY) {
                    setScrollYDirection('down');
                } else {
                    setScrollYDirection('up');
                }
                setScrollYPosition(scrollY);
                prevScrollY = scrollY;
            }
        }
    }

    const throttleUpdatePosition = useMemo(() => throttle(updatePosition, waitTime), []);

    useEffect(() => {
        window.addEventListener("scroll", throttleUpdatePosition);
        updatePosition();
        return () => {
            window.removeEventListener("scroll", throttleUpdatePosition);
            throttleUpdatePosition.cancel();
        }
    }, []);

    return {
        scrollYPosition,
        scrollYDirection
    };
};

export default useScrollPosition;